'use strict';

require('../shell/includes.js');
require('./app.js');
require('./controller.js');
require('./utils.js');
require('./data/accountDefaults.js');
require('./models/registration.js');
require('./models/user.js');
require('./models/landscapeCompany.js');
require('./collections/landscapeCompanies.js');
require('./views/companiesAdder.js');
require('./views/registrationDetails.js');
require('./views/userDetails.js');
require('./views/postSignupPage.js');
